import type { ReactNode } from 'react';

import { useMountEffect } from '../hooks/useMountEffect';
import { env } from '../lib/env';
import { AppErrorBoundary } from './AppErrorBoundary';

export function AppProviders(input: { children: ReactNode }) {
  return (
    <>
      <CanonicalLocalhostSync />
      <AppErrorBoundary>{input.children}</AppErrorBoundary>
    </>
  );
}

function CanonicalLocalhostSync() {
  useMountEffect(() => {
    const canonicalUrl = readCanonicalLocalhostUrl();

    if (canonicalUrl === null) {
      return;
    }

    window.location.replace(canonicalUrl);
  });

  return null;
}
function readCanonicalLocalhostUrl() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (env.VITE_APP_ENV !== 'development') {
    return null;
  }

  if (window.location.hostname !== '127.0.0.1') {
    return null;
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.hostname = 'localhost';

  return nextUrl.toString();
}
